<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Destek Merkezi</h1>
        <el-button-group class="YeniBtn">
          <a class="el-button el-button--default el-button--mini" href="https://www.aidatim.com/sss"
             target="_blank">SIK SORULAN SORULAR</a>
          <a class="el-button el-button--default el-button--mini" href="https://www.aidatim.com/kilavuz"
             target="_blank">Kılavuz</a>
          <a class="el-button el-button--default el-button--mini" href="https://www.aidatim.com/icerik-merkezi"
             target="_blank">İçerik Merkezi</a>
          <a class="el-button el-button--default el-button--mini" href="https://www.aidatim.com/bilgi-arsivi"
             target="_blank">Yönetici Kütüphanesi</a>
          <a class="el-button el-button--primary el-button--mini" href="#"
             @click="$Tawk.$toggle()">canlı destek</a>
        </el-button-group>
      </div>
      <div class="icerik">
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-row :gutter="24">
          <el-col :span="4">
            <a class="btn-block text-center el-button--small mb-2 tx-IBM el-button--primary" :disabled="!TalepEkle"
               @click="TalepEkle=true">YENİ TALEP OLUŞTUR</a>
            <div class="borcliste vezne" :style="'height:'+Height+'px' ">
              <el-input
                v-if="Talepler"
                placeholder="Arama"
                prefix-icon="el-icon-search"
                v-model="search">
              </el-input>
              <ul v-if="Talepler" :style="'height:'+(Height-75)+'px' ">
                <li
                  v-for="t in Talepler.filter(data => !search || data.Unvan.toLowerCase().includes(search.toLowerCase()))"
                  @click="Talep_id=t.id" :class="t.id===Talep_id?'Aktif':''">
                  <div class="kisiBilgi">
                    <span class="borcAd">{{ t.Baslik }}</span>
                    <span class="borcBina">{{ t.tarih }}</span>
                    <span class="text-primary"><b>{{ t.DurumText }}</b></span>
                  </div>

                </li>
                <el-alert
                  :closable="false"
                  v-if="!Talepler.filter(data => !search || data.Baslik.toLowerCase().includes(search.toLowerCase()))[0]"
                  title="Uygun Kayıt Bulunamadı"
                  type="error">
                </el-alert>
              </ul>
            </div>
          </el-col>
          <el-col :span="16" class="DestekSayfa">
            <el-alert
              v-if="!Talep_id && !TalepEkle"
              title="Filtreleme Yapınız"
              type="info"
              :closable="false"
              description="Verilere erişebilemek için lütfen filtreleme yapınız"
            ></el-alert>
            <el-form v-if="TalepEkle" :rules="FormHata" :model="Form"
                     @submit.prevent.native="YeniTalep"
                     ref="RaporForm">
              <h5 class="Baslik">DESTEK TALEBİ OLUŞTUR
                <a class="pull-right text-kirmizi" style="float: right !important;" @click="TalepEkle=false"><i
                  class="feather-x"></i></a>
              </h5>
              <el-form-item label="Başlık" prop="Baslik">
                <el-input v-model="Form.Baslik"></el-input>
              </el-form-item>
              <el-form-item label="İçerik" prop="Icerik">
                <el-input type="textarea" :row="5" v-model="Form.Icerik"></el-input>
              </el-form-item>
              <el-button :loading="lo" @click="YeniTalep" class="btn-block" type="primary" size="small">Talep Ekle
              </el-button>
            </el-form>
            <DestekDetay v-if="Talep_id && !TalepEkle" :id="Talep_id"></DestekDetay>
          </el-col>
          <el-col :span="4">
            <el-divider content-position="left">Çağrı Merkezi</el-divider>
            <div class="sosyalmedya">
              <a href="https://api.whatsapp.com/send?phone=908508403806&text=Merhaba" target="_blank"
                 style="margin-right:10px"><img
                src="https://cdn.mudu.pro/Design/whatsapp.png" width="18"> <b style="color: #333">0850 840 3806</b></a>
              <br>
              <a href="tel:+908508403806" style="margin-right:10px"><img src="https://cdn.mudu.pro/Design/support.png"
                                                                         width="18"> <b style="color: #333">0850 840
                3806</b></a>
            </div>

            <el-divider content-position="left">Sosyal Medya</el-divider>
            <div class="sosyalmedya">
              <a href="https://www.facebook.com/aidatimcom"><img src="https://cdn.mudu.pro/Design/facebook.png"
                                                                 width="24"
                                                                 style="margin-right:10px"></a>
              <a href="https://instagram.com/aidatimcom"><img src="https://cdn.mudu.pro/Design/instagram.png" width="24"
                                                              style="margin-right:10px"></a>
              <a href="https://www.linkedin.com/company/11463880"><img src="https://cdn.mudu.pro/Design/linkedin.png"
                                                                       width="24" style="margin-right:10px"></a>
              <a href="https://www.youtube.com/channel/UCAbynImav3Q-Onz-Z0cAVNg"><img
                src="https://cdn.mudu.pro/Design/youtube.png" width="24" style="margin-right:10px"></a>
            </div>

          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>


<script>

import DestekDetay from "./DestekDetay";
import Yukleniyor from "../Yukleniyor";

export default {
  components: {DestekDetay, Yukleniyor},
  data() {
    return {
      Height: window.innerHeight - 150,
      Form: {
        Baslik: '',
        Icerik: ''
      },
      FormHata: {
        Baslik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Icerik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      search: '',
      lo: false,
      TalepEkle: false,
      Talep_id: null,
      Talepler: null
    }
  },
  methods: {
    YeniTalep() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/destek/yeni'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.Talep_id = response.id;
                this.$message.success(response.Mesaj);
                this.Form = {
                  Baslik: '',
                  Icerik: ''
                }
                this.TalepEkle = false
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },
    TalepGetir() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/destek/talepler/'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Talep_id = null;
            this.Talepler = response.Liste;
          }
        });
    }
  },
  created() {
    this.TalepGetir();
  },
  computed: {
    SayfaYenile() {
      return this.Modal
    },
  },
  watch: {
    SayfaYenile() {
      this.TalepGetir();
    },
  }
}
</script>

<style scoped>
.Talepler {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #dddfe7;
  border-radius: 0 0 4px 4px;
  margin-top: -10px;
  padding-top: 20px;
  padding-bottom: 20px;
  height: 77vh;
  overflow: scroll;
}

.Talepler li:last-child {
  border-bottom: 0;
}

.Talepler li.aktif {
  background-color: #00c391;
}

.Talepler li {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  color: #333;
  font-size: 12px;
  cursor: pointer;
  height: 56px;
  line-height: 18px;
}

.Talepler li span.Baslik {
  display: block;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.Talepler li span.Firma {
  float: left;
  width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 10px;
}

.Talepler li span.tarih {
  float: right;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/Destek/DestekSayfa.vue